import { merge } from 'effector';
import { createGate } from 'effector-react';
import { pending } from 'patronum';
import { storageApi } from '@shared/api/storage/storage';
import { createForm } from '@unicorn/effector-form';
import { SavedFilter, SavedFilters } from '../../types';
import {
  GetStoragePayload,
  GetStorageResponse,
  UpdateStoragePayload,
  UpdateStorageResponse,
} from '../../types/savedFilters/api';
import { FilterToolbarDomain } from '../main';

export const SaveFiltersGate = createGate();

export const $savedFilters = FilterToolbarDomain.createStore<SavedFilters>([]);

export const deleteSavedFilters = FilterToolbarDomain.createEvent<SavedFilter>();

export const fxGetStorage = FilterToolbarDomain.createEffect<
  GetStoragePayload,
  GetStorageResponse,
  Error
>().use(storageApi.getStorage);
export const fxUpdateStorage = FilterToolbarDomain.createEffect<
  UpdateStoragePayload,
  UpdateStorageResponse,
  Error
>().use(storageApi.updateStorage);

export const filterNameForm = createForm({
  initialValues: { filterName: '' },
  resetOn: [fxUpdateStorage, SaveFiltersGate.close],
});

export const $error = FilterToolbarDomain.createStore<Error | null>(null);
export const clearError = FilterToolbarDomain.createEvent();

export const $isLocalLoading = pending({
  effects: [fxGetStorage],
});

export const $isLoading = pending({
  effects: [fxUpdateStorage],
});

export const errorOccured = merge([fxGetStorage.fail, fxUpdateStorage.fail]);
